export const messageConstants = {
    SEND_MESSAGE_REQUEST: 'SEND_MESSAGE_REQUEST',
    SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
    SEND_MESSAGE_FAILURE: 'SEND_MESSAGE_FAILURE',

    GET_MESSAGE_REQUEST: 'GET_MESSAGE_REQUEST',
    GET_MESSAGE_SUCCESS: 'GET_MESSAGE_SUCCESS',
    GET_MESSAGE_FAILURE: 'GET_MESSAGE_FAILURE',
}